module.exports = __webpack_public_path__ + "media/images/consumer/icons/playstore-05059326ebc094834024af6e7705c3b3.png";